import { Button, Image } from "antd";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSession } from "../../../../api/Sessions";
import { useUser } from "../../../../api/Users";
import { useImageSrc } from "../../../../hooks/useImage";
import {
  useSessionGuest,
  useSessionValidation,
} from "../../../../hooks/useSession";
import { AuthContext } from "../../../../useAuth";
import Lobby from "./Lobby";

const SessionLobby = () => {
  const [session, setSession] = useState();
  const [sessionTitle, setSessionTitle] = useState("");

  const { id } = useParams();
  const { user } = useContext(AuthContext);

  const { isLoading: loadingSession, data } = useSession(id, user?.UserId);

  useEffect(() => {
    if (data) setSession(data);
  }, [data]);

  useEffect(() => {
    setSessionTitle(session?.session?.Category);
  }, [session]);

  // TODO: Validate session attendee & time
  const valid = useSessionValidation(session?.attendees);
  const guest = useSessionGuest(session?.attendees);
  const { isLoading: loadingGuest, data: guestUser } = useUser(guest?.UserId);
  const guestAvatar = useImageSrc(guestUser?.User?.Avatar);

  return (
    <Lobby
      loading={loadingGuest || loadingSession}
      title={`${sessionTitle} Session`}
      description={`with ${guestUser?.User?.FirstName}`}
      identity={user?.FirstName}
      roomName={session?.session?.SessionId}
      cover={
        <>
          <Image src={guestAvatar} preview={false} />
        </>
      }
    ></Lobby>
  );
};

export default SessionLobby;
